import { Link } from "react-router-dom";
import { ArrowRight, CalendarClock } from "lucide-react";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { UPCOMING_SERVICES } from "@/data/site";

const Services = () => (
  <div data-testid="services-page">
    <Seo
      title="Planning Services"
      description="Fixed-scope professional planning services for NSW property owners — feasibility reviews, pre-purchase due diligence and application support."
    />
    <section className="bg-sand-light py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Eyebrow>Planning Services</Eyebrow>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl text-teal">
          Fixed-scope professional services — launching soon
        </h1>
        <p className="mt-5 max-w-2xl text-charcoal/70 leading-relaxed">
          PLAN FIRST NSW is growing into defined, fixed-scope planning services: written reports,
          statutory documents and lodgement support. Each service will launch with a clear scope,
          deliverables and a quoted price.
        </p>
      </div>
    </section>

    <section className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-charcoal/50" data-testid="services-badge">
            Upcoming fixed-scope services
          </p>
        </FadeIn>
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {UPCOMING_SERVICES.map((s, i) => (
            <FadeIn key={s.title} delay={(i % 3) * 0.08} className="h-full">
              <div className="h-full bg-white border border-cloud p-8 flex flex-col hover:border-teal hover:-translate-y-1 hover:shadow-lg transition-all duration-300" data-testid={`service-card-${i}`}>
                <span className="inline-flex w-fit items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.14em] text-teal bg-sand-light px-3 py-1.5">
                  <CalendarClock className="w-3.5 h-3.5" /> {s.timeline}
                </span>
                <h2 className="mt-5 font-serif text-xl text-teal tracking-tight leading-snug">
                  {s.title}
                </h2>
                <p className="mt-3 text-sm text-charcoal/70 leading-relaxed flex-1">{s.scope}</p>
                <p className="mt-6 text-xs text-charcoal/50">
                  Scope, deliverables and pricing published at launch.
                </p>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn className="mt-16">
          <div className="bg-teal text-ivory p-10 lg:p-14 flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
            <div>
              <h2 className="font-serif text-2xl sm:text-3xl tracking-tight">
                Need help before these launch?
              </h2>
              <p className="mt-3 text-ivory/70 max-w-xl leading-relaxed">
                Consultations are available now. A one-on-one session with an experienced NSW
                planner can resolve most early questions — and map exactly which professional
                services your project needs.
              </p>
            </div>
            <Link
              to="/book"
              data-testid="services-cta-book"
              className="shrink-0 inline-flex items-center gap-2 bg-sand text-teal-dark font-semibold px-7 py-3.5 rounded-full hover:bg-ivory transition-colors"
            >
              Book a consultation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  </div>
);

export default Services;
